import { z } from 'zod';

// Work Application Schema
export const workSchema = z.object({
  name: z.string()
    .min(3, 'Nome deve ter no mínimo 3 caracteres')
    .max(100, 'Nome muito longo'),
  email: z.string()
    .email('Email inválido')
    .toLowerCase(),
  phone: z.string()
    .min(14, 'Telefone inválido')
    .max(15, 'Telefone inválido')
    .regex(/^\(\d{2}\)\s\d{4,5}-\d{4}$/, 'Formato: (00) 00000-0000'),
  specialty: z.string()
    .min(1, 'Selecione uma especialidade'),
  experience: z.string()
    .min(50, 'Descreva sua experiência com mais detalhes')
    .max(1000, 'Texto muito longo')
});

export type WorkApplicationFormData = z.infer<typeof workSchema>;